import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Phone, MessageCircle } from "lucide-react";

const FAQS = [
  {
    q: "Wat als er meerwerk nodig is — krijg ik dan een verrassing op de rekening?",
    a: "Nee. Wij meten eerst gratis bij jou thuis op en geven daarna een vaste prijs. Komt er onverhoopt iets onverwachts naar boven (bijvoorbeeld verrotte leidingen achter een muur), dan bespreken we dit eerst met jou en geef je akkoord vóórdat er extra werk wordt uitgevoerd. Geen verborgen kosten.",
  },
  {
    q: "Hoe snel kunnen jullie inplannen?",
    a: "Meestal binnen 1 tot 3 weken na akkoord op de offerte. We werken op volgorde van binnenkomst — daarom geldt: vol is vol. Bel of WhatsApp De Toiletman op 06 154 60 576 voor de actuele beschikbaarheid.",
  },
  {
    q: "Klopt het echt dat jullie binnen 3 dagen klaar zijn?",
    a: "Ja. Een standaard toiletrenovatie ronden we gemiddeld in 3 werkdagen af: dag 1 sloop & leidingen, dag 2 inbouwframe & tegelwerk, dag 3 afkitten & afmonteren. Bij grotere projecten communiceren we vooraf een afwijkende planning.",
  },
  {
    q: "Welke garantie krijg ik op het werk?",
    a: "Je krijgt 2 jaar garantie op al ons uitgevoerde werk. Mocht er iets niet goed zitten, dan komen we dit kosteloos verhelpen. Op de geleverde materialen geldt de fabrieksgarantie.",
  },
  {
    q: "Wat is inbegrepen in de prijs vanaf €1200?",
    a: "Voor een toiletrenovatie (vanaf €1200): sloop en afvoer van het oude toilet, aanpassen van leidingen, plaatsen van een Geberit inbouwframe, tegelwerk wand & vloer, plaatsen hangtoilet met bedieningsplaat, afkitten en complete oplevering. Voor een complete badkamerrenovatie geldt vanaf €6000 — inclusief douche/bad, wastafel met meubel, sanitair en volledig tegelwerk. Eindprijs altijd na gratis inmeting.",
  },
  {
    q: "Mag ik zelf de tegels en het toilet uitkiezen?",
    a: "Zeker. Je kiest zelf je stijl en wij denken graag mee. We kunnen alle materialen voor je inkopen, of jij levert ze aan — net wat jij wil.",
  },
  {
    q: "In welke regio werken jullie?",
    a: "We werken voornamelijk in de regio Amsterdam, Amstelveen, Uithoorn en omstreken. Twijfel je of jouw adres binnen ons werkgebied valt? Bel even, we komen verder dan je denkt.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="bg-slate-50 py-20 lg:py-28"
      data-testid="faq-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-orange-500">
            Veelgestelde vragen
          </p>
          <h2 className="font-display font-bold mt-3 text-4xl sm:text-5xl tracking-tight text-slate-900">
            Alles wat je wil{" "}
            <span className="text-blue-700">weten</span>{" "}
            voordat je belt.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Geen vraag te gek. Staat jouw vraag er niet tussen? Stuur een
            berichtje en De Toiletman helpt je persoonlijk.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="tel:+31615460576"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full bg-blue-700 hover:bg-blue-800 text-white font-semibold transition-colors"
              data-testid="faq-call-btn"
            >
              <Phone className="w-4 h-4" />
              Bel direct
            </a>
            <a
              href="https://wa.me/31615460576?text=Hoi%2C%20ik%20heb%20een%20vraag%20over%20een%20toiletrenovatie."
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold transition-colors"
              data-testid="faq-whatsapp-btn"
            >
              <MessageCircle className="w-4 h-4" />
              Stel je vraag
            </a>
          </div>
        </div>

        {/* Centered accordion */}
        <div className="mt-12 max-w-3xl mx-auto">
          <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white border border-slate-200 rounded-2xl px-6 data-[state=open]:border-blue-700 transition-colors"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display font-semibold text-lg text-slate-900 hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-base pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
